var map = {
	"./": [
		1608,
		608
	],
	"./about-us": [
		1697,
		906,
		428
	],
	"./about-us/": [
		1697,
		906,
		428
	],
	"./about-us/index": [
		1697,
		906,
		428
	],
	"./about-us/index.vue": [
		1697,
		906,
		428
	],
	"./afterpay": [
		7125,
		906,
		908
	],
	"./afterpay/": [
		7125,
		906,
		908
	],
	"./afterpay/index": [
		7125,
		906,
		908
	],
	"./afterpay/index.vue": [
		7125,
		906,
		908
	],
	"./checkout-payment": [
		533,
		776,
		533
	],
	"./checkout-payment/": [
		533,
		776,
		533
	],
	"./checkout-payment/index": [
		533,
		776,
		533
	],
	"./checkout-payment/index.vue": [
		533,
		776,
		533
	],
	"./checkout-payment/pay-button": [
		1776,
		776
	],
	"./checkout-payment/pay-button.vue": [
		1776,
		776
	],
	"./clearpay": [
		1882,
		906,
		454
	],
	"./clearpay/": [
		1882,
		906,
		454
	],
	"./clearpay/index": [
		1882,
		906,
		454
	],
	"./clearpay/index.vue": [
		1882,
		906,
		454
	],
	"./color-chart": [
		9552,
		439,
		169
	],
	"./color-chart/": [
		9552,
		439,
		169
	],
	"./color-chart/index": [
		9552,
		439,
		169
	],
	"./color-chart/index.vue": [
		9552,
		439,
		169
	],
	"./color-chart/main": [
		4439,
		439,
		221
	],
	"./color-chart/main.vue": [
		4439,
		439,
		221
	],
	"./contact-us": [
		7989,
		989
	],
	"./contact-us/": [
		7989,
		989
	],
	"./contact-us/index": [
		7989,
		989
	],
	"./contact-us/index.vue": [
		7989,
		989
	],
	"./faq": [
		2071,
		71
	],
	"./faq/": [
		2071,
		71
	],
	"./faq/index": [
		2071,
		71
	],
	"./faq/index.vue": [
		2071,
		71
	],
	"./index": [
		1608,
		608
	],
	"./index.vue": [
		1608,
		608
	],
	"./klarna": [
		8018,
		18
	],
	"./klarna/": [
		8018,
		18
	],
	"./klarna/index": [
		8018,
		18
	],
	"./klarna/index.vue": [
		8018,
		18
	],
	"./order-cancellation": [
		2135,
		135
	],
	"./order-cancellation/": [
		2135,
		135
	],
	"./order-cancellation/components/cancellation-form": [
		8875,
		875
	],
	"./order-cancellation/components/cancellation-form.vue": [
		8875,
		875
	],
	"./order-cancellation/components/cancellation-time": [
		8750,
		750
	],
	"./order-cancellation/components/cancellation-time.vue": [
		8750,
		750
	],
	"./order-cancellation/components/cancellation-tips": [
		5099,
		99
	],
	"./order-cancellation/components/cancellation-tips.vue": [
		5099,
		99
	],
	"./order-cancellation/index": [
		2135,
		135
	],
	"./order-cancellation/index.vue": [
		2135,
		135
	],
	"./payment-methods": [
		2636,
		636
	],
	"./payment-methods/": [
		2636,
		636
	],
	"./payment-methods/desc": [
		2738,
		738
	],
	"./payment-methods/desc.vue": [
		2738,
		738
	],
	"./payment-methods/index": [
		2636,
		636
	],
	"./payment-methods/index.vue": [
		2636,
		636
	],
	"./paypal": [
		6045,
		45
	],
	"./paypal-page": [
		7089,
		89
	],
	"./paypal-page/": [
		7089,
		89
	],
	"./paypal-page/index": [
		7089,
		89
	],
	"./paypal-page/index.vue": [
		7089,
		89
	],
	"./paypal/": [
		6045,
		45
	],
	"./paypal/index": [
		6045,
		45
	],
	"./paypal/index.vue": [
		6045,
		45
	],
	"./privacy-policy": [
		2112,
		112
	],
	"./privacy-policy/": [
		2112,
		112
	],
	"./privacy-policy/index": [
		2112,
		112
	],
	"./privacy-policy/index.vue": [
		2112,
		112
	],
	"./project-tailor-made": [
		4846,
		906,
		901
	],
	"./project-tailor-made/": [
		4846,
		906,
		901
	],
	"./project-tailor-made/components/parallax": [
		906,
		906,
		337
	],
	"./project-tailor-made/components/parallax.vue": [
		906,
		906,
		337
	],
	"./project-tailor-made/index": [
		4846,
		906,
		901
	],
	"./project-tailor-made/index.vue": [
		4846,
		906,
		901
	],
	"./returns-refund": [
		3040,
		40
	],
	"./returns-refund/": [
		3040,
		40
	],
	"./returns-refund/index": [
		3040,
		40
	],
	"./returns-refund/index.vue": [
		3040,
		40
	],
	"./shipping-info": [
		1418,
		418
	],
	"./shipping-info/": [
		1418,
		418
	],
	"./shipping-info/components/shipping-about": [
		4179,
		179
	],
	"./shipping-info/components/shipping-about.vue": [
		4179,
		179
	],
	"./shipping-info/components/shipping-rush-order": [
		1584,
		584
	],
	"./shipping-info/components/shipping-rush-order.vue": [
		1584,
		584
	],
	"./shipping-info/components/shipping-time": [
		6122,
		98
	],
	"./shipping-info/components/shipping-time.vue": [
		6122,
		98
	],
	"./shipping-info/index": [
		1418,
		418
	],
	"./shipping-info/index.vue": [
		1418,
		418
	],
	"./size-guide": [
		4298,
		298
	],
	"./size-guide/": [
		4298,
		298
	],
	"./size-guide/components/dress": [
		122,
		122
	],
	"./size-guide/components/dress.vue": [
		122,
		122
	],
	"./size-guide/components/flower-girls": [
		4469,
		469
	],
	"./size-guide/components/flower-girls.vue": [
		4469,
		469
	],
	"./size-guide/components/jackets-wraps": [
		9456,
		456
	],
	"./size-guide/components/jackets-wraps.vue": [
		9456,
		456
	],
	"./size-guide/components/junior-bridesmaid": [
		3216,
		216
	],
	"./size-guide/components/junior-bridesmaid.vue": [
		3216,
		216
	],
	"./size-guide/components/menSuits": [
		9066,
		66
	],
	"./size-guide/components/menSuits.vue": [
		9066,
		66
	],
	"./size-guide/components/shoes": [
		2132,
		132
	],
	"./size-guide/components/shoes.vue": [
		2132,
		132
	],
	"./size-guide/index": [
		4298,
		298
	],
	"./size-guide/index.vue": [
		4298,
		298
	],
	"./size/dress": [
		8917,
		917
	],
	"./size/dress.vue": [
		8917,
		917
	],
	"./size/flower-girl-dress": [
		6634,
		634
	],
	"./size/flower-girl-dress.vue": [
		6634,
		634
	],
	"./size/jewelry": [
		4293,
		293
	],
	"./size/jewelry.vue": [
		4293,
		293
	],
	"./size/lingerie": [
		512,
		512
	],
	"./size/lingerie.vue": [
		512,
		512
	],
	"./size/menSuits": [
		1795,
		795
	],
	"./size/menSuits.vue": [
		1795,
		795
	],
	"./size/pajamas": [
		7682,
		682
	],
	"./size/pajamas.vue": [
		7682,
		682
	],
	"./size/rings": [
		7625,
		625
	],
	"./size/rings.vue": [
		7625,
		625
	],
	"./size/shoes": [
		6744,
		744
	],
	"./size/shoes.vue": [
		6744,
		744
	],
	"./size/wrap": [
		1342,
		342
	],
	"./size/wrap.vue": [
		1342,
		342
	],
	"./terms-conditions": [
		8991,
		991
	],
	"./terms-conditions/": [
		8991,
		991
	],
	"./terms-conditions/index": [
		8991,
		991
	],
	"./terms-conditions/index.vue": [
		8991,
		991
	],
	"./ticket": [
		878,
		878
	],
	"./ticket/": [
		878,
		878
	],
	"./ticket/index": [
		878,
		878
	],
	"./ticket/index.vue": [
		878,
		878
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7611;
module.exports = webpackAsyncContext;